import { useEffect } from "react";
import { OneKycEvents } from "src/constants";
import { fromEnv } from "../../../../../helpers";

const { GetOrigin, SendOrigin, Callback } = OneKycEvents;

export const useOneKycEventListener = (handleResult: (data: any) => void) => {
  useEffect(() => {
    const kycHost = fromEnv("REACT_APP_ONE_KYC_LIVENESS_HOST");

    const initConnectionHandler = (event: MessageEvent) => {
      if (event.data?.type !== GetOrigin) return;

      const sourceWindow = event.source as Window;
      sourceWindow?.postMessage({ type: SendOrigin }, event.origin);
    };

    const callbackHandler = (event: MessageEvent) => {
      if (event.origin !== kycHost || event.data.type !== Callback) return;

      handleResult(event.data?.data);
    };

    window.addEventListener("message", initConnectionHandler);
    window.addEventListener("message", callbackHandler);

    return () => {
      window.removeEventListener("message", initConnectionHandler);
      window.removeEventListener("message", callbackHandler);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
